import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { MouseEvent, useState } from 'react'
import { SalesOrderOvItem } from 'store/SalesOrderContext/types/ovsList'
import { theme } from 'styles/theme/hav-theme'

import * as S from './styles'
import { usePermissions } from 'commons/customHooks/useAuth'
import { ACTIONS_SCREENS, SCREENS } from 'commons/utils/permissions'
import { ActionPerm } from 'components/Structures/Header/constants'
import { Icon } from 'components'
import { OVTypes } from 'constants/enums'

type OvListMenuProps = {
  ov: SalesOrderOvItem
  handleSap: (action: string, ov?: SalesOrderOvItem) => void
  handleSendSap: (ov?: SalesOrderOvItem) => void
  handleDelete: (ov?: SalesOrderOvItem) => void
  handleCancel: (ov?: SalesOrderOvItem) => void
}

const OvListMenu = ({
  ov,
  handleSap,
  handleSendSap,
  handleDelete,
  handleCancel
}: OvListMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const { verifyPermission } = usePermissions()
  function shouldDisablePermission(action: ActionPerm) {
    return !verifyPermission(SCREENS.OV, action)
  }

  const customStyle = {
    color: theme.colors.primary.main,
    fontSize: theme.typography.sizes.xs
  }

  const checkItemActions = () => {
    const isCancelEnabled =
      +ov.StatusNumber >= 0 &&
      +ov.StatusNumber <= 8 &&
      ov.NumeroOrdemVendaSap &&
      !shouldDisablePermission(ACTIONS_SCREENS.CANCEL)

    const isDeleteEnabled =
      !ov.NumeroOrdemVendaSap && !shouldDisablePermission(ACTIONS_SCREENS.DELETE)

    const returnStatus = [9, 10, 15, 20, 21, 22, 40, 45]
    const isReturnEnabled =
      returnStatus.includes(+ov.StatusNumber) &&
      !shouldDisablePermission(ACTIONS_SCREENS.RETURN)

    const isSendEnabled =
      +ov.StatusNumber >= 0 &&
      +ov.StatusNumber <= 8 &&
      !shouldDisablePermission(ACTIONS_SCREENS.SEND) &&
      ov.TipoOrdemVenda !== OVTypes.YRBA

    return {
      cancel: isCancelEnabled,
      delete: isDeleteEnabled,
      return: isReturnEnabled,
      send: isSendEnabled
    }
  }

  const shouldDisable = () => {
    const actions = checkItemActions()
    return !(actions.cancel || actions.delete || actions.return || actions.send)
  }

  return (
    <>
      <S.ButtonStyled
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        disabled={shouldDisable()}
      >
        <Icon
          icon="ellipsis"
          color={
            shouldDisable() ? theme.colors.neutral.lighthover : theme.colors.primary.main
          }
          size="15"
        />
      </S.ButtonStyled>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        {checkItemActions().send && (
          <MenuItem
            onClick={() => {
              handleSendSap(ov)
              handleClose()
            }}
            sx={customStyle}
          >
            Enviar
          </MenuItem>
        )}
        {checkItemActions().return && (
          <MenuItem
            onClick={() => {
              handleSap('retornar', ov)
              handleClose()
            }}
            sx={customStyle}
          >
            Retornar
          </MenuItem>
        )}
        {checkItemActions().delete && (
          <MenuItem
            onClick={() => {
              handleDelete(ov)
              handleClose()
            }}
            sx={customStyle}
          >
            Excluir
          </MenuItem>
        )}
        {checkItemActions().cancel && (
          <MenuItem
            onClick={() => {
              handleCancel(ov)
              handleClose()
            }}
            sx={customStyle}
          >
            Cancelar
          </MenuItem>
        )}
      </Menu>
    </>
  )
}

export default OvListMenu
